import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'svg-icon',
  templateUrl: './svg-icon.component.html',
  styleUrls: ['./svg-icon.component.scss'],
})
export class SvgIconComponent implements OnInit {
  @Input('icon') icon = '';
  @Input('classes') style = '';
  @Input('isActive') isActive = false;
  @Input('isButtonIcon') isButtonIcon = false;
  @Input('figurenone') figurenone = false;
  @Input('showTooltip') showTooltip = false;
  @Input() center = false;
  @Input() iconActive: boolean = false;
  @Input() width?: number | string;
  @Input() height?: number | string;

  url = '';
  ngOnInit(): void {
    this.url = `assets/icons/${this.icon.trim()}.svg`;
  }

  get hasCustomSize(): boolean {
    return this.width !== undefined || this.height !== undefined;
  }

  get customWidthValue(): string {
    if (this.width === undefined) return '';
    return typeof this.width === 'number' ? `${this.width}px` : this.width;
  }

  get customHeightValue(): string {
    if (this.height === undefined) return '';
    return typeof this.height === 'number' ? `${this.height}px` : this.height;
  }
}
